(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';
  var FETCH_TIMEOUT = 8000;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), ' +
                  'select, textarea, [tabindex]:not([tabindex="-1"])';

  function themeName() {
    try {
      return (window.theme && window.theme.settings && window.theme.settings.themeName) || 'st';
    } catch (e) {
      return 'st';
    }
  }

  function firstNumber(text) {
    var m = String(text || '').match(/-?\d+(?:[.,]\d+)?/);
    return m ? parseFloat(m[0].replace(',', '.')) : null;
  }

  function areaValue(text) {
    var m = String(text || '').match(/(\d+(?:[.,]\d+)?)\s*[×xX]\s*(\d+(?:[.,]\d+)?)/);
    if (!m) return firstNumber(text);
    return parseFloat(m[1].replace(',', '.')) * parseFloat(m[2].replace(',', '.'));
  }

  class StCompare extends HTMLElement {
    connectedCallback() {
      this.collection = this.dataset.collection || '';
      this.url = this.dataset.compareUrl || '';
      this.limitDesktop = parseInt(this.dataset.limitDesktop, 10) || 4;
      this.limitMobile = parseInt(this.dataset.limitMobile, 10) || 3;
      this.storageKey = themeName() + ':compare';

      this.bar = this.querySelector('[data-cmp-bar]');
      this.thumbs = this.querySelector('[data-cmp-thumbs]');
      this.count = this.querySelector('[data-cmp-count]');
      this.badge = this.querySelector('[data-cmp-badge]');
      this.remaining = this.querySelector('[data-cmp-remaining]');
      this.collapseBtn = this.querySelector('[data-cmp-collapse]');
      this.openBtn = this.querySelector('[data-cmp-open]');
      this.resetBtn = this.querySelector('[data-cmp-reset]');
      this.drawer = this.querySelector('[data-cmp-drawer]');
      this.scrim = this.querySelector('[data-cmp-scrim]');
      this.closeBtn = this.querySelector('[data-cmp-close]');
      this.scroll = this.querySelector('[data-cmp-scroll]');
      this.diffOnly = this.querySelector('[data-cmp-diff]');

      this.mql = window.matchMedia(MOBILE_QUERY);
      this.onViewport = this.enforceLimit.bind(this);
      if (this.mql.addEventListener) this.mql.addEventListener('change', this.onViewport);

      var saved = this.restore();
      this.selected = saved.handles;
      this.meta = saved.meta;
      this.lastCount = this.selected.length;

      this.tableHTML = null;
      this.fetchPromise = null;
      this.controller = null;
      this.lastFocus = null;
      this.scrollLocked = false;
      this.padded = false;

      this.onChange = this.onChange.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      document.addEventListener('change', this.onChange);
      document.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKeydown);

      if (this.openBtn) this.openBtn.addEventListener('click', this.open.bind(this));
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.close.bind(this));
      if (this.scrim) this.scrim.addEventListener('click', this.close.bind(this));
      if (this.resetBtn) {
        this.resetBtn.addEventListener('click', function () {
          this.selected = [];
          this.close();
          this.sync();
        }.bind(this));
      }
      if (this.diffOnly) this.diffOnly.addEventListener('change', this.paint.bind(this));

      this.collapseKey = this.storageKey + ':collapsed';
      if (this.collapseBtn) {
        this.collapseBtn.addEventListener('click', this.toggleCollapsed.bind(this));
        var stored = null;
        try { stored = window.localStorage.getItem(this.collapseKey); } catch (e) {}
        // Mobile always starts as the collapsed bar: the open panel covers the category chips
        // (each chip switch reconnects this element). Wrike 4584025633, 19.10.
        var startCollapsed = this.isMobile() || stored === '1';
        this.setCollapsed(startCollapsed);
      }

      this.sync();
    }

    disconnectedCallback() {
      this.teardown();
    }

    teardown() {
      document.removeEventListener('change', this.onChange);
      document.removeEventListener('click', this.onClick);
      document.removeEventListener('keydown', this.onKeydown);
      if (this.mql && this.mql.removeEventListener) {
        this.mql.removeEventListener('change', this.onViewport);
      }
      if (this.controller) this.controller.abort();
      this.releaseScroll();
      this.releasePadding();
      document.body.classList.remove('st-compare-open');
    }

    lockScroll() {
      if (this.scrollLocked) return;
      // Counter, not a flag: closing compare must not release an open cart drawer lock.
      StCompare.locks = (StCompare.locks || 0) + 1;
      this.scrollLocked = true;
      if (StCompare.locks === 1) {
        StCompare.savedScrollY = window.scrollY || window.pageYOffset || 0;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = (-StCompare.savedScrollY) + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      }
    }

    releaseScroll() {
      if (!this.scrollLocked) return;
      this.scrollLocked = false;
      StCompare.locks = Math.max(0, (StCompare.locks || 0) - 1);
      if (StCompare.locks === 0) {
        var y = StCompare.savedScrollY || 0;
        document.documentElement.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, y);
      }
    }

    releasePadding() {
      if (!this.padded) return;
      this.padded = false;
      document.body.style.paddingBlockEnd = '';
    }

    limit() {
      return this.mql && this.mql.matches ? this.limitMobile : this.limitDesktop;
    }

    restore() {
      var empty = { handles: [], meta: {} };
      try {
        var raw = window.localStorage.getItem(this.storageKey);
        if (!raw) return empty;
        var data = JSON.parse(raw);
        if (!data || data.collection !== this.collection) return empty;
        return {
          handles: Array.isArray(data.handles) ? data.handles.slice(0, this.limit()) : [],
          meta: data.meta && typeof data.meta === 'object' ? data.meta : {}
        };
      } catch (e) {
        return empty;
      }
    }

    persist() {
      try {
        window.localStorage.setItem(this.storageKey, JSON.stringify({
          collection: this.collection,
          handles: this.selected,
          meta: this.meta
        }));
      } catch (e) { }
    }

    harvestMeta() {
      var boxes = document.querySelectorAll('[data-st-compare]');
      for (var i = 0; i < boxes.length; i++) {
        var b = boxes[i];
        this.meta[b.dataset.handle] = {
          title: b.dataset.title || b.dataset.handle,
          image: b.dataset.image || ''
        };
      }
    }

    enforceLimit() {
      if (this.selected.length > this.limit()) {
        this.selected = this.selected.slice(0, this.limit());
      }
      this.sync();
    }

    track(action) {
      var detail = { action: action, collection: this.collection, handles: this.selected.slice() };
      document.dispatchEvent(new CustomEvent('st:compare', { detail: detail, bubbles: true }));
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'st_compare', st_compare: detail });
      }
    }

    onChange(event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('[data-st-compare]')) return;

      var handle = input.dataset.handle;
      if (input.checked) {
        if (this.selected.indexOf(handle) === -1) {
          if (this.selected.length >= this.limit()) {
            input.checked = false;
            return;
          }
          this.selected.push(handle);
          this.track('add');
        }
      } else {
        this.selected = this.selected.filter(function (h) { return h !== handle; });
        this.track('remove');
      }
      this.sync();
    }

    onClick(event) {
      var drop = event.target.closest ? event.target.closest('[data-cmp-drop]') : null;
      if (!drop) return;
      event.preventDefault();
      this.remove(drop.dataset.cmpDrop);
    }

    onKeydown(event) {
      if (!this.drawer || this.drawer.dataset.open !== 'true') return;

      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;

      var items = Array.prototype.filter.call(
        this.drawer.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    remove(handle) {
      this.selected = this.selected.filter(function (h) { return h !== handle; });
      this.track('remove');
      if (this.selected.length < 2) this.close();
      this.sync();
    }

    sync() {
      this.harvestMeta();
      this.persist();
      this.syncCheckboxes();
      this.syncBar();
      if (this.drawer && this.drawer.dataset.open === 'true') this.paint();
    }

    syncCheckboxes() {
      var full = this.selected.length >= this.limit();
      var boxes = document.querySelectorAll('[data-st-compare]');
      for (var i = 0; i < boxes.length; i++) {
        var box = boxes[i];
        var on = this.selected.indexOf(box.dataset.handle) !== -1;
        box.checked = on;
        box.disabled = full && !on;
      }
    }

    syncBar() {
      if (!this.bar) return;
      var open = this.selected.length > 0;
      this.bar.dataset.open = String(open);

      var count = this.selected.length;
      // Desktop only: on mobile the panel opens on the user's tap only, so chip taps always go through.
      if (this.lastCount < 2 && count >= 2 && !this.isMobile()) this.setCollapsed(false);
      this.lastCount = count;

      if (this.thumbs) {
        this.thumbs.textContent = '';
        this.selected.forEach(function (handle) {
          var meta = this.meta[handle] || { title: handle, image: '' };

          var row = document.createElement('li');
          row.className = 'st-cmp-row';

          var thumb = document.createElement('span');
          thumb.className = 'st-cmp-row__thumb';
          if (meta.image) {
            var img = document.createElement('img');
            img.src = meta.image;
            img.alt = '';
            img.loading = 'lazy';
            img.width = 44;
            img.height = 44;
            thumb.appendChild(img);
          }
          row.appendChild(thumb);

          var name = document.createElement('span');
          name.className = 'st-cmp-row__name';
          name.textContent = meta.title;
          name.title = meta.title;
          row.appendChild(name);

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'st-cmp-drop';
          btn.setAttribute('data-cmp-drop', handle);
          btn.setAttribute('aria-label',
            (this.bar.dataset.removeLabel || '%s').replace('%s', meta.title));
          btn.innerHTML = this.bar.dataset.closeIcon || '';
          row.appendChild(btn);

          this.thumbs.appendChild(row);
        }, this);
      }

      if (this.remaining) {
        var left = this.limit() - this.selected.length;
        if (left > 0 && open) {
          this.remaining.textContent = (this.bar.dataset.remainingTemplate || '')
            .replace('%s', left);
          this.remaining.hidden = false;
        } else {
          this.remaining.hidden = true;
        }
      }

      if (this.count) {
        this.count.textContent = (this.count.dataset.template || '')
          .replace('%1', this.selected.length)
          .replace('%2', this.limit());
      }
      if (this.badge) this.badge.textContent = String(this.selected.length);
      if (this.openBtn) {
        this.openBtn.disabled = this.selected.length < 2;
        var label = this.openBtn.querySelector('[data-cmp-open-label]') || this.openBtn;
        label.textContent = (this.openBtn.dataset.template || '')
          .replace('%s', this.selected.length);
      }

      }

    setCollapsed(state) {
      this.collapsed = !!state;
      this.bar.dataset.collapsed = String(this.collapsed);
      if (this.collapseBtn) {
        this.collapseBtn.setAttribute('aria-expanded', String(!this.collapsed));
        var ds = this.collapseBtn.dataset;
        var label = this.collapsed ? ds.labelExpand : ds.labelCollapse;
        if (label) this.collapseBtn.setAttribute('aria-label', label);
      }
      if (this.isMobile()) return;  // the stored state is the desktop preference
      try { window.localStorage.setItem(this.collapseKey, this.collapsed ? '1' : '0'); } catch (e) {}
    }

    isMobile() {
      return !!(this.mql && this.mql.matches);
    }

    toggleCollapsed() {
      this.setCollapsed(!this.collapsed);
    }

    fetchUrl() {
      var url = new URL(this.url, window.location.href);
      try {
        var id = window.Shopify && window.Shopify.theme && window.Shopify.theme.id;
        if (id) url.searchParams.set('preview_theme_id', String(id));
      } catch (e) { }
      return url.pathname + url.search;
    }

    loadTable() {
      this.controller = new AbortController();
      var timer = setTimeout(function () { this.controller.abort(); }.bind(this), FETCH_TIMEOUT);

      return fetch(this.fetchUrl(), {
        headers: { 'X-Requested-With': 'fetch' },
        signal: this.controller.signal
      }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      }).then(function (text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var table = parsed.querySelector('.st-cmp-table');
        if (!table) throw new Error('Fragment ohne Tabelle');
        // Carry the horizontal-scroll wrapper along with the table (falls
        // back to the bare table if a fragment predates the wrapper).
        var found = table.closest('.st-cmp-table-wrap') || table;
        this.tableHTML = found.outerHTML;

        if (table.dataset.truncated) {
          console.warn('[st-compare] Tabelle auf ' + table.dataset.truncated +
                       ' Produkte begrenzt — Auswahl darueber hinaus hat keine Spalte.');
        }
        return true;
      }.bind(this)).catch(function () {
        this.tableHTML = '';
        return false;
      }.bind(this)).then(function (ok) {
        clearTimeout(timer);
        this.controller = null;
        this.fetchPromise = null;
        return ok;
      }.bind(this));
    }

    async open() {
      if (this.selected.length < 2) return;
      this.lastFocus = document.activeElement;
      this.drawer.dataset.open = 'true';
      this.drawer.setAttribute('aria-hidden', 'false');
      this.scrim.dataset.open = 'true';
      this.lockScroll();
      // Own class, not has-modal-open: that one also carries the Concept scroll lock.
      document.body.classList.add('st-compare-open');
      this.track('open');

      try {
        if (!this.tableHTML) {
          this.scroll.innerHTML = '<p class="st-cmp-drawer__empty">'
            + (this.scroll.dataset.loading || '…') + '</p>';
          if (!this.fetchPromise) this.fetchPromise = this.loadTable();
          var ok = await this.fetchPromise;
          if (!ok) {
            this.scroll.innerHTML = '<p class="st-cmp-drawer__empty">'
              + (this.scroll.dataset.error || 'Fehler') + '</p>';
            return;
          }
          if (this.drawer.dataset.open !== 'true') return;  // zwischenzeitlich geschlossen
        }
        this.paint();
        if (this.closeBtn) this.closeBtn.focus();
      } catch (e) {
        this.close();
        throw e;
      }
    }

    close() {
      if (!this.drawer) return;
      this.drawer.dataset.open = 'false';
      this.drawer.setAttribute('aria-hidden', 'true');
      this.scrim.dataset.open = 'false';
      this.releaseScroll();
      document.body.classList.remove('st-compare-open');
      if (this.controller) this.controller.abort();
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }

    paint() {
      if (!this.tableHTML) return;
      if (!this.scroll.querySelector('.st-cmp-table')) {
        this.scroll.innerHTML = this.tableHTML;
      }
      var table = this.scroll.querySelector('.st-cmp-table');
      if (!table) return;

      var picked = this.selected;
      var cells = table.querySelectorAll('[data-handle]');
      for (var i = 0; i < cells.length; i++) {
        cells[i].style.display = picked.indexOf(cells[i].dataset.handle) === -1 ? 'none' : '';
      }

      var hideSame = this.diffOnly && this.diffOnly.checked;
      var rows = table.querySelectorAll('tbody tr');

      for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        var visible = [];
        var rowCells = row.querySelectorAll('[data-handle]');
        for (var c = 0; c < rowCells.length; c++) {
          if (picked.indexOf(rowCells[c].dataset.handle) !== -1) visible.push(rowCells[c]);
        }

        var old = row.querySelectorAll('.st-cmp-best');
        for (var o = 0; o < old.length; o++) old[o].remove();

        var texts = visible.map(function (cell) {
          return (cell.dataset.raw || cell.textContent).trim();
        });
        var filled = texts.filter(function (t) { return t !== '' && t !== '—'; });
        var allSame = filled.length > 1
          && filled.length === visible.length
          && filled.every(function (t) { return t === filled[0]; });

        // Empty check runs over the SELECTION, not the collection: two products without
        // LED must not show an LED row just because a third one in the collection has it.
        var noneFilled = filled.length === 0;

        row.style.display = (noneFilled || (hideSame && allSame)) ? 'none' : '';
        if (row.style.display === 'none') continue;

        var dir = row.dataset.dir;
        if (!dir) continue;

        var parse = row.dataset.kind === 'area' ? areaValue : firstNumber;
        var nums = visible.map(function (cell) { return parse(cell.dataset.raw || cell.textContent); });
        var valid = nums.filter(function (n) { return n !== null && !isNaN(n); });
        var uniq = valid.filter(function (v, idx, arr) { return arr.indexOf(v) === idx; });
        if (uniq.length < 2) continue;

        var best = dir === 'low' ? Math.min.apply(null, valid) : Math.max.apply(null, valid);
        for (var v = 0; v < visible.length; v++) {
          if (nums[v] === best) {
            visible[v].insertAdjacentHTML('beforeend', table.dataset.bestBadge || '');
          }
        }
      }

      this.syncGroups(table);
      this.syncColCount(table);
    }

    syncGroups(table) {
      // colspan must track the selection: with table-layout:fixed a stale colspan
      // keeps hidden columns claiming width, squeezing the visible cards.
      var span = this.selected.length + 1;
      var heads = table.querySelectorAll('tr.st-cmp-group');
      for (var i = 0; i < heads.length; i++) {
        var head = heads[i];
        var cell = head.querySelector('th, td');
        if (cell) cell.colSpan = span;

        var any = false;
        var next = head.nextElementSibling;
        while (next && !next.classList.contains('st-cmp-group')) {
          if (next.style.display !== 'none') { any = true; break; }
          next = next.nextElementSibling;
        }
        head.style.display = any ? '' : 'none';
      }
    }

    syncColCount(table) {
      table.dataset.cols = String(this.selected.length);

      var el = table.querySelector('[data-cmp-colcount]');
      if (!el || !el.dataset.template) return;
      el.textContent = el.dataset.template.replace('%s', this.selected.length);
    }
  }

  StCompare.locks = 0;

  if (!window.customElements.get('st-compare')) {
    window.customElements.define('st-compare', StCompare);
  }
})();
